import { useId } from "react";
import { useTranslation } from "react-i18next";
import type { CartPetSummary } from "@/lib/sales/cart-pets";

/** "Pets nesta venda": só leitura; muda quando um item troca de pet no carrinho. */
export const SalePetsSummary = ({ pets }: { pets: CartPetSummary[] }) => {
  const { t } = useTranslation("erp");
  const labelId = useId();

  if (pets.length === 0) return null;

  return (
    <div className="space-y-2">
      <p id={labelId} className="text-sm font-medium leading-none">
        {t("patientCpf.petsInSale")}
      </p>
      <ul aria-labelledby={labelId} aria-live="polite" className="flex flex-wrap gap-2">
        {pets.map((pet) => (
          <li
            key={pet.petId}
            className="inline-flex min-h-9 items-center gap-1.5 rounded-full border border-primary bg-accent px-3 text-sm text-accent-foreground"
          >
            <span className="font-semibold">{pet.name}</span>
            {pet.count > 0 && <span>{t("patientCpf.petItemCount", { count: pet.count })}</span>}
          </li>
        ))}
      </ul>
    </div>
  );
};
